// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"OffersListBO_nameCell__2N9yD","button":"OffersListBO_button__2nA7F"};